import { FillButton, Tooltip, FillPreview } from '@wix/design-system';
import t__default, { useContext } from 'react';
import { a } from '../../RevertSmall-778c3822.js';
import classNames from 'classnames';
import { RicosContext, ZIndexContext } from 'ricos-context';
import { s as styleInject } from '../../style-inject.es-e7b07dd7.js';
import { SWATCHES, RESET_COLOR_BUTTON, ADD_CUSTOM_COLOR_BUTTON, SWATCH } from './data-hooks.js';

var css_248z = ".C8mlI{display:grid;gap:var(--ricos-color-picker-color-swatch-gap,12px);grid-template-columns:repeat(auto-fill,var(--ricos-color-picker-color-swatch-size,24px));justify-content:space-between}.Ibv7d{width:var(--ricos-color-picker-color-swatch-size,24px)}._9qUaB{--ricos-color-picker-color-swatch-size:36px}";
var classes = {"container":"C8mlI","colorSwatch":"Ibv7d","medium":"_9qUaB"};
styleInject(css_248z);

const ColorSwatches = ({
  userColors,
  selectedColor,
  onAddClick,
  onChange,
  size = "small",
  allowEmpty,
  showResetButton
}) => {
  const { t } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);
  return /* @__PURE__ */ t__default.createElement(
    "div",
    {
      className: classNames(classes.container, {
        [classes.medium]: size === "medium"
      }),
      "data-hook": SWATCHES
    },
    showResetButton && /* @__PURE__ */ t__default.createElement(
      FillButton,
      {
        icon: /* @__PURE__ */ t__default.createElement(a, null),
        iconSize: "medium",
        onClick: () => onChange(void 0),
        dataHook: RESET_COLOR_BUTTON,
        tooltipContent: t("ColorPickerResetColor_Tooltip"),
        tooltipProps: {
          appendTo: (el) => {
            var _a;
            return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
          },
          zIndex: zIndexService.getZIndex("TOOLTIP")
        }
      }
    ),
    /* @__PURE__ */ t__default.createElement(
      FillButton,
      {
        iconSize: "medium",
        onClick: onAddClick,
        dataHook: ADD_CUSTOM_COLOR_BUTTON,
        tooltipContent: t("ColorPickerAddCustomColor_Tooltip"),
        tooltipProps: {
          appendTo: (el) => {
            var _a;
            return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
          },
          zIndex: zIndexService.getZIndex("TOOLTIP")
        }
      }
    ),
    allowEmpty && /* @__PURE__ */ t__default.createElement(EmptyColorSwatch, { onClick: onChange, selected: selectedColor === void 0 }),
    userColors.map((userColor) => /* @__PURE__ */ t__default.createElement(
      ColorSwatch,
      {
        key: userColor,
        fill: userColor,
        selectedColor,
        onClick: onChange
      }
    ))
  );
};
const ColorSwatch = ({ fill, selectedColor, onClick }) => {
  return /* @__PURE__ */ t__default.createElement(
    Tooltip,
    {
      appendTo: (el) => {
        var _a;
        return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
      },
      content: fill,
      dataHook: "color-swatch-tooltip"
    },
    /* @__PURE__ */ t__default.createElement(
      FillPreview,
      {
        className: classes.colorSwatch,
        selected: selectedColor === fill,
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick(fill);
        },
        fill,
        dataHook: SWATCH
      }
    )
  );
};
const EmptyColorSwatch = ({
  onClick,
  selected
}) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ t__default.createElement(
    Tooltip,
    {
      appendTo: (el) => {
        var _a;
        return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
      },
      content: t("ColorPicker_RemoveColor_Tooltip"),
      dataHook: "color-swatch-tooltip"
    },
    /* @__PURE__ */ t__default.createElement(
      FillPreview,
      {
        className: classes.colorSwatch,
        onClick: () => onClick(void 0),
        selected,
        dataHook: SWATCH
      }
    )
  );
};

export { ColorSwatches };
//# sourceMappingURL=color-swatches.js.map
